import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  authVar: {
    signUp: false,
    login: false,
    recovery: false
  },
  userData: {
    birthDate: null,
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    password: null,
    thumbnail: null,
    socialFrom: 'local',
    socialId: null,
    points: 'none',
    eMoney: 0,
    locale: ''
  },
  tours: [],
  config: {
    activeTour: '',
    drawler: null,
    language: 'ro'
  }
}

const getters = {

}

const mutations = {
  set (state, { type, items }) {
    Object.keys(items).map((key, index) => {
      if (key !== '__v') state[type][key] = items[key]
    })
  },
  var (state, { type, i, v }) {
    state[type][i] = v
  }
}

const actions = {
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js